/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext, useRef, useState, useEffect } from "react";
import styled from "@emotion/styled";
import BurgerButton from "../BurgerButton";
import { ModalContext, ModalType } from "@src/components/modals/ModalController";
import { getRelativePath } from "@src/utils/routes";
import { logEvent } from "@src/utils/logClient";
import window from "global/window";
import NavLinks from "../partials/header/NavLinks";
import * as S from "./styles";
import FocusTrap from "focus-trap-react";
import useOnClickOutside from "@src/utils/useClickOutside";
import { useFeatureFlagsWithOverrides } from "@src/utils/useFeatureFlag";
import useSearchParams from "@src/utils/useSearchParams";
import { AppDataContext } from "@src/components/AppDataContext";
import DistrictsHelloBar from "@src/components/Header/DistrictsHelloBar";
import { mediaQueries } from "@src/styles/theme";

const MobileBackground = styled.div`
  background-color: white;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1;
  ${mediaQueries[2]} {
    display: none;
  }
`;

type HeaderProps = {
  showNavBanner: boolean;
  inSchools: boolean;
  hideNav: boolean;
  unpinHeader: boolean;
  closeBannerFunction: () => void;
  handleIsUserInAudience: (newValue: boolean) => void;
  simplifiedHeader?: boolean;
};

const Header: React.FC<HeaderProps> = ({ hideNav, unpinHeader, handleIsUserInAudience, simplifiedHeader }) => {
  const [headerOpen, setHeaderOpen] = useState<boolean>(false);
  const toggleHeader = () => setHeaderOpen(!headerOpen);
  const { showModal } = useContext(ModalContext);
  const showTeacherSignupModal = () => showModal(ModalType.TeacherSignupForm);
  const showSignupModal = () => showModal(ModalType.Signup);

  const teacherSignupParam = useSearchParams("teacher-signup");
  const generalSignupParam = useSearchParams("create-account");
  const modalContext = useContext(ModalContext);
  const featureFlags = useFeatureFlagsWithOverrides();

  const {
    data: { loadingSession, type },
  } = useContext(AppDataContext);

  // defining audience for banner
  useEffect(() => {
    if (!loadingSession && type === undefined) {
      handleIsUserInAudience(true);
    }
  }, [loadingSession, type]);

  useEffect(() => {
    if (teacherSignupParam[0] !== null) showTeacherSignupModal();
    if (generalSignupParam[0] !== null) showSignupModal();
  }, []);

  function openLoginModal() {
    logEvent({ eventValue: window.location.href, eventName: "web.external_page.navbar.log_in.tap" });
    modalContext.showModal(ModalType.Login);
  }

  function openSignupModal() {
    logEvent({
      eventValue: window.location.href,
      eventName: "web.external_page.navbar.sign_up.tap",
      metadata: featureFlags,
    });
    modalContext.showModal(ModalType.Signup);
  }
  const ref = useRef(null);
  useOnClickOutside(ref, () => setHeaderOpen(false));

  return (
    <S.Nav role="navigation" unpinHeader={unpinHeader}>
      {!simplifiedHeader && <DistrictsHelloBar />}
      <S.HeaderContainer height="100%" simplifiedHeader={simplifiedHeader}>
        <a href={getRelativePath("/")}>
          <S.Logo src="https://static.classdojo.com/img/classdojo-light.svg" alt="ClassDojo" />
        </a>

        {!hideNav && (
          <FocusTrap active={headerOpen}>
            <div role="dialog" aria-modal="true" ref={ref} css={{ width: "100%" }}>
              {!simplifiedHeader && (
                <>
                  <BurgerButton onClick={toggleHeader} active={headerOpen} aria-expanded={headerOpen} />
                  <NavLinks
                    openLoginModal={openLoginModal}
                    openSignupModal={openSignupModal}
                    closeMenu={() => setHeaderOpen(false)}
                    active={headerOpen}
                  />
                  <MobileBackground />
                </>
              )}
            </div>
          </FocusTrap>
        )}
      </S.HeaderContainer>
    </S.Nav>
  );
};

export default Header;
